@if (dataloaded === false) {
  <div class="loading-indicator-section">
    <mat-spinner class="spinner" mode="indeterminate">
    </mat-spinner>
  </div>
} @else {
  <form #generalInfoForm="ngForm" (ngSubmit)="onSubmit(generalInfoForm)" novalidate>
    <div fxLayout="row"></div>
    <mat-card>
      <mat-card-title class="title" fxLayout.gt-xs="row" fxLayout.xs="column">
        Candidate Personal Info
      </mat-card-title>
      <mat-card-content>
        @if (!editMode) {
          <div fxLayout="row wrap">
            <mat-label>Intern Number: {{intern.internNumber}}</mat-label>
          </div>
        }
        <div fxLayout="row" style="margin:12px"></div>
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
          @if (showCompanyList) {
            <mat-form-field>
              <mat-label>Company</mat-label>
              <mat-select [disabled]="disableCompanyList" placeholder="Company" class="form-control"
                [(ngModel)]="intern.company" name="company" required [compareWith]="compareCompanies">
                @for (company of authSvs.user?.userCompanies; track company; let i = $index) {
                  <mat-option
                  [value]="company">{{company.description}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (editMode) {
            <mat-form-field>
              <mat-label>States</mat-label>
              <mat-select placeholder="State" class="form-control" [(ngModel)]="intern.stateId"
                (selectionChange)="getProgramPath()" name="stateId" required>
                @for (state of statesList; track state; let i = $index) {
                  <mat-option
                  [value]="state.Id">{{state.StateName}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (editMode && programPathList.length) {
            <mat-form-field>
              <mat-label>Program Path</mat-label>
              <mat-select placeholder="Program Path" class="form-control" [(ngModel)]="intern.programPathId"
                name="programPathId" required>
                @for (path of programPathList; track path; let i = $index) {
                  <mat-option
                  [value]="path.id">{{path.description}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <mat-form-field>
            <mat-label>State ID</mat-label>
            <div fxFlex fxFlexAlign="center">
              <input matInput placeholder="State ID" class="form-control" [(ngModel)]="intern.stateLicenseId"
                name="stateLicenseId" />
              </div>
            </mat-form-field>
            <mat-checkbox [(ngModel)]="intern.claimedOnStateWebsite" name="claimedOnStateWebsite">
              Claimed on State website
            </mat-checkbox>
          </div>
          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
            <mat-form-field>
              <mat-label>First Name</mat-label>
              <div fxFlex fxFlexAlign="center">
                <input matInput placeholder="First Name" class="form-control" [(ngModel)]="intern.firstName" required
                  name="firstName" />
                </div>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Last Name</mat-label>
                <div fxFlex fxFlexAlign="center">
                  <input matInput placeholder="Last Name" class="form-control" [(ngModel)]="intern.lastName" required
                    name="lastName" />
                  </div>
                </mat-form-field>
                <div fxFlex fxFlexAlign="center">
                  <mat-form-field class="suffix">
                    <mat-label>Suffix</mat-label>
                    <mat-select placeholder="Suffix" class="form-control" [(ngModel)]="intern.suffix" name="suffix">
                      @for (suffix of suffixes; track suffix; let i = $index) {
                        <mat-option [value]="suffix.Id">
                          {{suffix.Description}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                <mat-form-field>
                  <mat-label>Middle Name</mat-label>
                  <div fxFlex fxFlexAlign="center">
                    <input matInput placeholder="Middle Name" class="form-control" [(ngModel)]="intern.middleName"
                      name="middleName" />
                    </div>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Maiden Name</mat-label>
                    <div fxFlex fxFlexAlign="center">
                      <input matInput placeholder="Maiden Name" class="form-control" [(ngModel)]="intern.maidenName"
                        name="maidenName" />
                      </div>
                    </mat-form-field>
                  </div>
                  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                    <mat-form-field>
                      <mat-label>Preferred Name</mat-label>
                      <div fxFlex fxFlexAlign="center">
                        <input matInput placeholder="Preferred Name" class="form-control" [(ngModel)]="intern.preferredName"
                          name="preferredName" />
                        </div>
                      </mat-form-field>
                      <div fxFlex fxFlexAlign="center">
                        <mat-form-field>
                          <mat-label>Gender</mat-label>
                          <mat-select placeholder="Gender" class="form-control" [(ngModel)]="intern.gender" name="gender" required>
                            @for (gender of genders; track gender; let i = $index) {
                              <mat-option [value]="gender.Id">
                                {{gender.Description}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                      <mat-form-field>
                        <mat-label>SSN</mat-label>
                        <div fxFlex fxFlexAlign="center">
                          <input matInput placeholder="SSN" class="form-control" [(ngModel)]="intern.ssn" name="ssn"
                            maxlength="11" (blur)="onSsnBlur()" />
                        </div>
                      </mat-form-field>
                      <div fxFlex fxFlexAlign="center">
                        <mat-form-field>
                          <mat-label>Date of Birth</mat-label>
                          <input matInput [matDatepicker]="picker" placeholder="Date of Birth" [(ngModel)]="intern.dob" name="dob">
                          <mat-datepicker-toggle matSuffix [for]="picker">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                      <mat-form-field>
                        <mat-label>Ethnicity</mat-label>
                        <mat-select placeholder="Ethnicity" class="form-control" [(ngModel)]="intern.ethnicity" name="ethnicity"
                          required>
                          @for (ethnicity of ethnicitys; track ethnicity; let i = $index) {
                            <mat-option [value]="ethnicity.Id">
                              {{ethnicity.Description}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <div fxFlex fxFlexAlign="center">
                        <mat-form-field>
                          <mat-label>Race</mat-label>
                          <mat-select placeholder="Race" class="form-control" [(ngModel)]="intern.race" name="race" required>
                            @for (race of races; track race; let i = $index) {
                              <mat-option [value]="race.Id">
                                {{race.Description}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                      <div fxFlex fxFlexAlign="center">
                        <mat-form-field class="federal-date">
                          <mat-label>Federal Background Check Date</mat-label>
                          <input matInput [matDatepicker]="federalbackgroundcheckpicker" placeholder="Federal Background Check Date"
                            [(ngModel)]="intern.federalBackgroundCheckDate" name="federalBackgroundCheckDate">
                            <mat-datepicker-toggle matSuffix [for]="federalbackgroundcheckpicker">
                              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #federalbackgroundcheckpicker></mat-datepicker>
                          </mat-form-field>
                        </div>
                      </div>
                      <div>
                        <mat-label>Military Status: {{getMilitaryStatus()}}</mat-label>
                      </div>
                    </mat-card-content>
                  </mat-card>
                  <mat-card>
                    <mat-card-title class="title" fxLayout.gt-xs="row" fxLayout.xs="column">
                      Address Info
                    </mat-card-title>
                    <mat-card-content>
                      @if ((intern.addresses != null && intern.addresses.length > 0)) {
                        <div>
                          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                            <mat-form-field style="width:400px;">
                              <mat-label>Address 1</mat-label>
                              <div fxFlex fxFlexAlign="center">
                                <input matInput placeholder="Address 1" class="form-control" [(ngModel)]="intern.addresses[0].address1"
                                  required name="address1" />
                                </div>
                              </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                              <mat-form-field style="width:400px;">
                                <mat-label>Address 2</mat-label>
                                <div fxFlex fxFlexAlign="center">
                                  <input matInput placeholder="Address 2" class="form-control" [(ngModel)]="intern.addresses[0].address2"
                                    name="address2" />
                                  </div>
                                </mat-form-field>
                              </div>
                              <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                                <mat-form-field>
                                  <mat-label>City</mat-label>
                                  <div fxFlex fxFlexAlign="center">
                                    <input matInput placeholder="City" class="form-control" [(ngModel)]="intern.addresses[0].city"
                                      name="city" required />
                                    </div>
                                  </mat-form-field>
                                  <div fxFlex fxFlexAlign="center">
                                    <mat-form-field>
                                      <mat-label>State</mat-label>
                                      <mat-select placeholder="State" class="form-control" [(ngModel)]="intern.addresses[0].state"
                                        name="state" required>
                                        @for (state of states; track state; let i = $index) {
                                          <mat-option [value]="state.Id">
                                            {{state.StateName}} ( {{ state.StateCode }} )
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                                  <mat-form-field>
                                    <mat-label>Zip Code</mat-label>
                                    <div fxFlex fxFlexAlign="center">
                                      <input matInput placeholder="Zip Code" class="form-control" [(ngModel)]="intern.addresses[0].zip"
                                        name="zip" required />
                                      </div>
                                    </mat-form-field>
                                    <div fxFlex fxFlexAlign="center">
                                      <mat-form-field>
                                        <mat-label>Country</mat-label>
                                        <mat-select placeholder="Country" class="form-control" [(ngModel)]="intern.addresses[0].country"
                                          name="country" required>
                                          @for (country of countries; track country; let i = $index) {
                                            <mat-option [value]="country.Id">
                                              {{country.CountryName}} ( {{ country.Code }} )
                                            </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                </div>
                              }
                            </mat-card-content>
                          </mat-card>
                          <mat-card>
                            <mat-card-title class="title" fxLayout.gt-xs="row" fxLayout.xs="column">
                              Application Info
                            </mat-card-title>
                            <mat-card-content>
                              <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                                <div fxFlex fxFlexAlign="center">
                                  <mat-form-field>
                                    <mat-label>Application Date</mat-label>
                                    <input matInput [matDatepicker]="applicationpicker" placeholder="Application Date"
                                      [(ngModel)]="intern.applicationDate" name="applicationDate" [disabled]="editMode != 'new'">
                                      <mat-datepicker-toggle matSuffix [for]="applicationpicker">
                                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                                      </mat-datepicker-toggle>
                                      <mat-datepicker #applicationpicker></mat-datepicker>
                                    </mat-form-field>
                                  </div>
                                  <div fxFlex fxFlexAlign="center">
                                    <mat-form-field>
                                      <mat-label>Admit Date</mat-label>
                                      <input matInput [matDatepicker]="admitpicker" placeholder="Admit Date" [(ngModel)]="intern.admitDate"
                                        name="admitDate" [disabled]="editMode != 'new'">
                                        <mat-datepicker-toggle matSuffix [for]="admitpicker">
                                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #admitpicker></mat-datepicker>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                                    <div fxFlex fxFlexAlign="center">
                                      <mat-form-field>
                                        <mat-label>Date offered admission</mat-label>
                                        <input matInput [matDatepicker]="offeredDatePicker" placeholder="Date offered admission"
                                          [(ngModel)]="intern.offeredAdmitDate" name="offeredAdmissionDate">
                                          <mat-datepicker-toggle matSuffix [for]="offeredDatePicker">
                                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                                          </mat-datepicker-toggle>
                                          <mat-datepicker #offeredDatePicker></mat-datepicker>
                                        </mat-form-field>
                                      </div>
                                    </div>
                                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                                      <div fxFlex fxFlexAlign="center">
                                        <mat-form-field>
                                          <mat-label>Referral Source</mat-label>
                                          <mat-select placeholder="Referral Source" class="form-control" [(ngModel)]="intern.referralSourceId"
                                            name="referralSource">
                                            @for (accountsource of accountsources; track accountsource) {
                                              <mat-option [value]="accountsource.Id">
                                                {{accountsource.Description}}
                                              </mat-option>
                                            }
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                      <div fxFlex fxFlexAlign="center">
                                        <mat-form-field>
                                          <mat-label>Referral Code</mat-label>
                                          <input matInput placeholder="Referral Code" class="form-control" [(ngModel)]="intern.referralIntern"
                                            name="referralInternNumber" />
                                          </mat-form-field>
                                        </div>
                                      </div>
                                      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                                        <div fxFlex fxFlexAlign="center">
                                          <mat-form-field>
                                            <mat-label>File Location</mat-label>
                                            <mat-select placeholder="File Location" class="form-control" [(ngModel)]="intern.fileLocationId"
                                              name="fileLocation">
                                              @for (filelocation of filelocations; track filelocation) {
                                                <mat-option [value]="filelocation.Id">
                                                  {{filelocation.Description}}
                                                </mat-option>
                                              }
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxFlex fxFlexAlign="center">
                                          <mat-checkbox color="warn" [(ngModel)]="intern.isVip" name="vip">VIP</mat-checkbox>
                                        </div>
                                      </div>
                                      <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="flex-start">
                                        <div fxFlex>
                                          @if (editMode !== 'new') {
                                            <mat-checkbox color="warn" [(ngModel)]="intern.isExcludedFromHcl" name="excludeFromHcl"
                                              >
                                              Exclude from HCL
                                            </mat-checkbox>
                                          }
                                        </div>
                                        <div fxFlex>
                                          <mat-checkbox color="warn" [(ngModel)]="intern.admittedThreshold" name="admittedThreshold">
                                            Admitted to 1st EPP prior to late hire threshold
                                          </mat-checkbox>
                                        </div>
                                        @if (!editMode) {
                                          <div fxFlex>
                                            <mat-checkbox disabled="true" color="warn" [(ngModel)]="intern.hasEducatorLicense" name="hasEducatorLicense">
                                              Has previous educator certificate/license/permit
                                            </mat-checkbox>
                                          </div>
                                        }
                                      </div>
                                    </mat-card-content>
                                  </mat-card>
                                  @if (hasUserEmail) {
                                    <mat-card>
                                      <mat-card-content>
                                        <table class="responsive-table">
                                          <tr class="email-phone-header">
                                            <th colspan="4" class="email-phone-text">Login Email</th>
                                            <th></th>
                                          </tr>
                                          <tr>
                                            <th colspan="2" class="text-left" style="padding-top:20px; width:60%;">
                                                  Email Address *
                                            </th>
                                          </tr>
                                          <tr>
                                            <td colspan="2" class="text-left">
                                              <mat-form-field class="long-w">
                                                <input matInput [(ngModel)]="intern.userEmailAddress" name="userEmailAddress" [required]="requiresLoginEmail" email #loginEmailCtrl="ngModel" />
                                                <mat-error *ngIf="loginEmailCtrl.hasError('required')">Login email is required.</mat-error>
                                                <mat-error *ngIf="loginEmailCtrl.hasError('email')">Enter a valid email address.</mat-error>
                                              </mat-form-field>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                          </tr>
                                          <tr>
                                            <td colspan="2" class="text-left" style="width:60%;">
                                              <p class="auth-email-legend">
                                                This email is used to access the Intern Portal. It can be updated but not deleted.<br>
                                                Updating this email will also change the login email for linked platforms such as Canvas, TLL, and others.
                                              </p>
                                            </td>
                                            <td style="width:15%;"></td>
                                            <td style="width:20%;"></td>
                                            <td></td>
                                          </tr>
                                        </table>
                                      </mat-card-content>
                                    </mat-card>
                                  }
                                  <mat-card>
                                    <mat-card-content>
                                      @if (intern != null && intern.emails != null) {
                                        <div>
                                            <table class="responsive-table">
                                              <tr class="email-phone-header">
                                                <th colspan="4" class="email-phone-text">Email Info</th>
                                                <th>
                                                  <button type="button" mat-raised-button (click)="addEmailRow()"
                                                    style="margin-left:10px; margin-top:6px; margin-bottom:6px">
                                                    Add
                                                  </button>
                                                </th>
                                              </tr>
                                              <tr>
                                                <th colspan="2" class="text-left" style="padding-top:20px; width:60%;">
                                                  Email Address *
                                                </th>
                                                <th class="text-center" style="padding-top:20px; width:15%;">Primary</th>
                                                <th class="text-center" style="padding-top:20px; width:20%;"></th>
                                                <th></th>
                                              </tr>
                                              @for (email of intern.emails; track email; let i = $index) {
                                                <tr>
                                                  @if (email.active) {
                                                    <td colspan="2" class="text-left">
                                                      <mat-form-field class="long-w">
                                                        <input matInput [(ngModel)]="email.emailAddress" name="emailAddress{{ i }}" required email #emailCtrl="ngModel" />
                                                        <mat-error *ngIf="emailCtrl.hasError('required')">Email is required.</mat-error>
                                                        <mat-error *ngIf="emailCtrl.hasError('email')">Enter a valid email address.</mat-error>
                                                      </mat-form-field>
                                                    </td>
                                                    <td class="text-center">
                                                      <mat-radio-button color="warn" [checked]="email === selectedEmail" (change)="primaryEmailSelected(email)"></mat-radio-button>
                                                    </td>
                                                    <td>
                                                      <button mat-raised-button (click)="deleteEmailRow(i)" [disabled]="disableEmailDelete(email)">
                                                        Delete
                                                      </button>
                                                      @if (selectedEmail === email) {
                                                        <div class="primary-required-msg">
                                                          Primary Email address is required
                                                        </div>
                                                      }
                                                    </td>
                                                    <td></td>
                                                  }
                                                </tr>
                                              }
                                              <tr>
                                                <td colspan="3"></td>
                                                <td>
                                                  <mat-checkbox [(ngModel)]="intern.doNotEmail" name="doNotEmail">
                                                    Do not email
                                                  </mat-checkbox>
                                                </td>
                                              </tr>
                                            </table>
                                        </div>
                                      }
                                    </mat-card-content>
                                  </mat-card>
                                  <mat-card>
                                    <mat-card-content>
                                      @if (intern != null && intern.phoneNumbers != null) {
                                        <div>
                                          <mat-radio-group [(ngModel)]="selectedPhone" class="radio-group" (change)="phoneRadioChanged()"
                                            name="selectedPhone">
                                            <table class="responsive-table">
                                              <tr class="email-phone-header">
                                                <th colspan="4" class="email-phone-text">Phone Info</th>
                                                <th>
                                                  <button type="button" mat-raised-button (click)="addPhoneRow()"
                                                    style="margin-left:10px;margin-top:6px;margin-bottom:6px">
                                                    Add
                                                  </button>
                                                </th>
                                              </tr>
                                              <tr>
                                                <th colspan="2" class="text-left" style="padding-top:20px;width:60%;">Phone Number</th>
                                                <th class="text-center" style="padding-top:20px;width:20%;">Primary</th>
                                                <th class="text-center" style="padding-top:20px;width:20%;"></th>
                                                <th></th>
                                              </tr>
                                              @for (phone of intern.phoneNumbers; track phone; let i = $index) {
                                                <tr>
                                                  @if (phone.active == true) {
                                                    <td colspan="2" class="text-left">
                                                      <mat-form-field>
                                                        <input matInput type="tel" [(ngModel)]="phone.phoneNumber" name="phoneNumber{{i}}" />
                                                      </mat-form-field>
                                                    </td>
                                                    <td class="text-center">
                                                      <mat-radio-button class="radio" color="warn" class="radio-button" [value]="phone">
                                                      </mat-radio-button>
                                                    </td>
                                                    <td>
                                                      <button class="delete-button" type="button" mat-raised-button (click)="deletePhoneRow(i)"
                                                        [disabled]="selectedPhone === phone">
                                                        Delete
                                                      </button>
                                                      @if (selectedPhone === phone) {
                                                        <div class="primary-required-msg">
                                                          Primary Phone Number is required
                                                        </div>
                                                      }
                                                    </td>
                                                    <td></td>
                                                  }
                                                </tr>
                                              }
                                            </table>
                                          </mat-radio-group>
                                        </div>
                                      }
                                    </mat-card-content>
                                  </mat-card>
                                  <mat-card>
                                    <mat-card-content fxLayoutAlign="flex-end">
                                      <button type="button" color="secondary" mat-raised-button (click)="cancel()">Cancel</button>
                                      <button type="button" color="secondary" mat-raised-button (click)="close()">Close</button>
                                      <div>
                                        <button type="submit" color="primary" [disabled]='submitClicked' mat-raised-button>Submit</button>
                                        @if (submitClicked) {
                                          <mat-progress-bar class="submit-progress-bar" mode="indeterminate"></mat-progress-bar>
                                        }
                                      </div>
                                    </mat-card-content>
                                  </mat-card>
                                </form>
                              }
